module.exports = __webpack_public_path__ + "ceacace4d4e174bcc075d535cb3fe250.png";